import { Button } from '@shared/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface ErrorStateProps {
  error: Error | null;
  onRetry?: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4">
      <AlertTriangle className="h-16 w-16 text-destructive" />
      <div className="text-center space-y-2">
        <h3 className="text-lg font-semibold text-foreground">Error al cargar los reembolsos</h3>
        <p className="text-sm text-muted-foreground">{error?.message || 'Ha ocurrido un error inesperado'}</p>
      </div>
      {onRetry && (
        <Button onClick={onRetry} variant="outline">
          Reintentar
        </Button>
      )}
    </div>
  );
};
